import React, { Fragment } from 'react';
import { Container, Row } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import TeamsTable from './TeamsTable';
const Teams = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle='Teams' parent='Teams'  />
      <Container fluid={true}>
        <Row>
          <TeamsTable />
        </Row>
      </Container>
    </Fragment>
  );
};

export default Teams;
